<template>
    <div>
        <v-form @submit.prevent="$refs.form?.isValid ? updatePersonalInformation() : ''" ref="form" class="helpical-cards">
            <v-img src="@/assets/img/editProfilePattern.png" class="overflow-visible mb-9 rounded-t" height="120" cover>
                <div class="d-flex align-center ga-3 mt-7 ms-4">
                    <file-input
                        :text="`<div class='text-small d-flex flex-column h-100 justify-center align-center'><span>آپلود تصویر پروفایل</span><span class='d-block'>فرمت: jpg, png</span><span class='d-block mt-n2'>سایز فایل: 200KB</span></div>`"
                        :style="{backgroundColor: '#e7e7e7', borderRadius: '50%', height: '120px', width: '120px'}"
                        :types="['jpg', 'png', 'jpeg']"
                        :mimeTypes="['image/jpg', 'image/png', 'image/jpeg']"
                        :size="204800"
                        type="image"
                        imageSize="fill"
                        ref="profileInput"
                        @updated="profileChanged"
                    ></file-input>
                    <div>
                        <p class="text-white mb-2">{{ $auth.user.first_name }} {{ $auth.user.last_name }}</p>
                        <p class="text-small text-white mb-1">تاریخ عضویت : {{ $moment($auth.user.created_at).format('jYYYY/jMM/jDD') }}</p>
                    </div>
                </div>
            </v-img>
            <v-col lg="10" cols="12">
                <custom-divider label="اطلاعات هویتی"></custom-divider>
                <v-row align="center" dense>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation('required')"
                            label="* نام"
                            v-model="form.first_name"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation('required')"
                            label="* نام خانوادگی"
                            v-model="form.last_name"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation([(username_type == 'username' ? 'required' : false), ($system.systemSettings.username_regex ? 'regex:' + $system.systemSettings.username_regex : false)].filter(Boolean))"
                            :disabled="form.username && !$system.systemSettings.username_change_permission"
                            label="نام کاربری"
                            v-model="form.username"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row align="center" dense>
                    <v-col md="3" sm="4" cols="12">
                        <datetime-input
                            label="تاریخ تولد"
                            type="date"
                            clearable
                            v-model="form.birthday"
                        ></datetime-input>
                    </v-col>
                    <v-col cols="auto">
                        <v-radio-group inline v-model="form.gender">
                            <p class="text-meta text-primary me-3 pt-1 font-weight-medium">جنسیت:</p>
                            <v-radio :value="true" label="مرد"></v-radio>
                            <v-radio :value="false" label="زن"></v-radio>
                            <v-radio :value="0" label="نامشخص"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <custom-divider label="اطلاعات تماس"></custom-divider>
                <v-row align="center" dense>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation(username_type == 'mobile' ? 'required' : '')"
                            label="شماره موبایل"
                            v-model="form.mobile"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation([(username_type == 'email' ? 'required' : false), 'email'].filter(Boolean))"
                            label="* ایمیل"
                            v-model="form.email"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                    <v-col class="d-none d-sm-block d-md-none" sm="4"></v-col>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation()"
                            label="شماره تماس ثابت"
                            v-model="form.landline"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                    <v-col md="2" sm="3" cols="12">
                        <v-text-field
                            :rules="$validation()"
                            label="داخلی"
                            v-model="form.interphone"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                </v-row>
                <v-row align="center" dense v-if="$auth.user.employee">
                    <v-col md="3" sm="4" cols="12">
                        <v-autocomplete
                            :items="countries"
                            @update:modelValue="form.state_id = null; form.city_id = null"
                            clearable
                            item-title="name"
                            item-value="id"
                            label="کشور"
                            no-data-text="موردی پیدا نشد!"
                            v-model="form.country_id"
                            autocomplete="new-password"
                        ></v-autocomplete>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                        <v-autocomplete
                            :disabled="form.country_id ? false : true"
                            :items="states.filter(x=> x.country_id == form.country_id)"
                            @update:modelValue="form.city_id = null"
                            clearable
                            item-title="name"
                            item-value="id"
                            label="استان"
                            no-data-text="موردی پیدا نشد!"
                            v-model="form.state_id"
                            autocomplete="new-password"
                        ></v-autocomplete>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                        <v-autocomplete
                            :disabled="form.state_id ? false : true"
                            :items="cities.filter(x=> x.state_id == form.state_id)"
                            clearable
                            item-title="name"
                            item-value="id"
                            label="شهر"
                            no-data-text="موردی پیدا نشد!"
                            v-model="form.city_id"
                            autocomplete="new-password"
                        ></v-autocomplete>
                    </v-col>
                </v-row>
                <v-row align="center" dense>
                    <v-col md="9" cols="12">
                        <v-textarea
                            :rules="$validation()"
                            label="آدرس"
                            no-resize
                            rows="3"
                            v-model="form.address"
                            autocomplete="new-password"
                        ></v-textarea>
                    </v-col>
                </v-row>
                <div v-if="haveCustomFields">
                    <custom-divider label="اطلاعات تکمیلی"></custom-divider>
                    <v-col sm="4" cols="12">
                        <custom-fields-form v-model="form.custom_fields" :items="customFieldItems"></custom-fields-form>
                    </v-col>
                </div>
            </v-col>
            <v-btn class="mt-n1 ms-5 mb-5 " type="submit" color="success">ثبت تغییرات</v-btn>
        </v-form>
        <v-form ref="secForm" class="helpical-cards mt-5" id="security" @submit.prevent="$refs.secForm.isValid ? (security_form.password === security_form.password_confirmation ? updateSecurityInformation() : $toast.error('کلمه عبور با تکرار کلمه عبور مطابقت ندارد')) : ''">
            <v-col lg="10" cols="12">
                <custom-divider label="تنظیمات کلمه عبور"></custom-divider>
                <v-row align="center" dense>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation('required')"
                            :append-inner-icon="pass1 ? 'visibility' : 'visibility_off'"
                            :type="pass1 ? 'password' : 'text'"
                            @click:appendInner="() => {pass1 = !pass1;}"
                            label="* کلمه عبور قبلی"
                            v-model="security_form.old_password"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation(['required', $system.systemSettings.force_users_using_secure_password ? 'complex' : false].filter(Boolean))"
                            :append-inner-icon="pass2 ? 'visibility' : 'visibility_off'"
                            :type="pass2 ? 'password' : 'text'"
                            @click:appendInner="() => {pass2 = !pass2}"
                            label="* کلمه عبور جدید"
                            v-model="security_form.password"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                    <v-col md="3" sm="4" cols="12">
                        <v-text-field
                            :rules="$validation(['required', $system.systemSettings.force_users_using_secure_password ? 'complex' : false].filter(Boolean))"
                            :append-inner-icon="pass3 ? 'visibility' : 'visibility_off'"
                            :type="pass3 ? 'password' : 'text'"
                            @click:appendInner="() => {pass3 = !pass3}"
                            label="* تکرار کلمه عبور جدید"
                            v-model="security_form.password_confirmation"
                            autocomplete="new-password"
                        ></v-text-field>
                    </v-col>
                    <v-btn type="submit" class="mb-5 ms-3 " color="success">ثبت تغییرات</v-btn>
                </v-row>
                <p v-if="$system.systemSettings.force_users_using_secure_password" class="text-small text-grey-darken-1">کلمه عبور می‌باید دارای حداقل 8 کاراکتر شامل حروف کوچک و بزرگ انگلیسی، اعداد و علامت‌های خاص باشد.</p>
            </v-col>
        </v-form>
        <div class="helpical-cards mt-5" v-if="$auth.user.employee">
            <v-col lg="10" cols="12">
                <custom-divider label="امضاء تیکت"></custom-divider>
                <p class="text-small text-grey-darken-1 mb-4">امضاء تیکت متنی است که می توانید آن را در پایین تمامی تیکت ها درج نمایید.</p>
                <v-data-table
                    :headers="signatureHeaders"
                    :items="signatureItems"
                    :items-per-page="-1"
                    hide-default-footer
                >
                    <template #item.signature="{ value }">
                        <span>{{ value ?? '----------' }}{{ value?.length > 50 ? "....." : "" }}</span>
                    </template>
                    <template #item.actions="{ item }">
                        <v-btn v-if="item.signature" @click="signatures[0].id = item.id; signatures[0].text = item.completeSignature; signatureSituation = 'edit'; editSignatureDialog = true;" color="secondary" icon="icon-edit" size="small" variant="text"></v-btn>
                        <v-btn v-if="item.signature" @click="deleteSignature(item.id)" color="error" icon="icon-trash" size="small" variant="text"></v-btn>
                        <v-btn v-else @click="signatures[0].id = item.id; signatures[0].text = item.completeSignature; signatureSituation = 'new'; editSignatureDialog = true;" color="success" size="small">ایجاد امضا</v-btn>
                    </template>
                </v-data-table>
            </v-col>
        </div>
        <div class="helpical-cards mt-5" v-if="$system.license.features.notice_telegram">
            <v-col lg="10" cols="12">
                <custom-divider label="اطلاع‌رسانی از طریق تلگرام"></custom-divider>
                <v-row>
                    <v-col sm="auto" cols="12">
                        <div class="rounded-lg bg-primary text-center pa-6 mx-auto position-relative" style="width:250px">
                            <div class="bg-white rounded pa-4 mx-auto" style="width:200px">
                                <qrcode-vue :value="'https://t.me/Helpical_G2_Bot' + ($auth.user.telegram_token ? '?start=' + $auth.user.telegram_token : '')" renderAs="svg" :size="160"></qrcode-vue>
                            </div>
                            <p class="mt-3 text-small text-white user-select-none font-weight-medium">برای اتصال به تلگرام اسکن کنید</p>
                            <v-overlay contained persistent :model-value="!$auth.user.telegram_token" style="background-color: #000000cc;"></v-overlay>
                        </div>
                        <p v-if="$auth.user.telegram_token" class="text-small mt-3 bg-grey-lighten-2 font-weight-medium text-center pa-2 rounded text-grey-darken-2">{{ $auth.user.telegram_token }}</p>
                        <div class="mt-2 text-center">
                            <v-btn v-if="$auth.user.telegram_token" class="me-1" color="secondary" :disabled="changeTelegramTokenLoading" @click="$text.copy($auth.user.telegram_token)">
                                <v-icon color="white" size="17" class="me-1" icon="icon-copy"></v-icon>کپی کلید رمز
                            </v-btn>
                            <v-btn :loading="changeTelegramTokenLoading" class="ms-1" color="success" @click="changeTelegramToken">
                                <v-icon color="white" size="17" class="me-1" icon="icon-key"></v-icon>{{ $auth.user.telegram_token ? 'تغییر کلید رمز' : 'ایجاد کلید رمز' }}
                            </v-btn>
                        </div>
                    </v-col>
                    <v-divider vertical inset class="d-none d-sm-block" opacity="0.4"></v-divider>
                    <v-col sm cols="12">
                        <p class="text-meta text-grey-darken-2 font-weight-medium">
                            <v-icon class="me-1" color="secondary" icon="info"></v-icon>راهنمای استفاده از ربات اطلاع رسانی تلگرام
                        </p>
                        <p class="mb-0 text-small text-grey-darken-2">
                            ربات تلگرام هلپیکال این امکان را برای شما فراهم خواهد آورد تا پیام های اطلاع رسانی مربوط به
                            دریافت تیکت های جدید و یا پاسخ تیکت ها را علاوه بر راه های دیگر نظیر ایمیل، پیامک و
                            نوتیفیکیشن های دسکتاپ، بر روی تلگرام خود نیز دریافت نمایید. برای این منظور مراحل زیر را انجام
                            دهید:
                            <br class="mb-5" />
                            <span class="rounded-circle bg-secondary d-inline-block me-2 pa-1"></span>ابتدا کلید رمز را از طریق دکمه ایجاد کلید رمز تولید کنید. دقت نمایید که این رمز تنها متعلق به شماست و نمی باید در اختیار شخص دیگری قرار گیرد.
                            <br class="mb-2" />
                            <span class="rounded-circle bg-secondary d-inline-block me-2 pa-1"></span>در مرورگر به آدرس <a href="https://t.me/Helpical_G2_Bot" target="_blank">https://t.me/Helpical_G2_Bot</a> مراجعه کنید و یا در تلگرام عبارت <span dir="ltr">@Helpical_G2_Bot</span> را جستجو نمایید تاوارد صفحه اول ربات تلگرام هلپیکال شوید.
                            <br class="mb-2" />
                            <span class="rounded-circle bg-secondary d-inline-block me-2 pa-1"></span>
                            با ورود به ربات، کد رمز بالا از شما درخواست می گردد. در این لحظه کد کپی شده را وارد نموده و
                            مراحل را ادامه دهید. در صورتیکه کد وارد شده شما صحیح باشد، اتصال شما به ربات تلگرام
                            هلپیکال برقرار خواهد شد.
                            <br class="mb-2" />
                            <span class="rounded-circle bg-secondary d-inline-block me-2 pa-1"></span>
                            حذف کد رمز از ربات تلگرام به هر دلیل، کافی است تا آنرا یک بار دیگر در این ربات وارد نمایید.
                        </p>
                    </v-col>
                </v-row>
            </v-col>
        </div>
        <v-dialog persistent v-model="editSignatureDialog" width="580">
            <v-card>
                <v-toolbar color="white">
                    <v-toolbar-title class="text-primary">{{ signatureSituation === 'new' ? 'ایجاد امضاء' : 'ویرایش امضاء' }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn @click="editSignatureDialog = false" icon>
                        <v-icon color="primary" size="23">close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-divider></v-divider>
                <ckeditor
                    v-model="signatures[0].text"
                    class="mt-3 px-4"
                    ref="ticketTemplatesTextEditor"
                />
                <v-card-actions class="py-4 px-5 bg-white">
                    <v-btn @click="updateSignature" variant="flat" color="success">ثبت اطلاعات</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn @click="editSignatureDialog = false" color="error" variant="text">بستن</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import QrcodeVue from 'qrcode.vue';
export default {
    title: "ویرایش حساب کاربری",
    components: {
      QrcodeVue
    },
    data() {
        return {
            pass1: true,
            pass2: true,
            pass3: true,
            changeTelegramTokenLoading: false,
            editSignatureDialog: false,
            name: null,
            created_at: null,
            countries: [],
            states: [],
            cities: [],
            signatureSituation:'new',
            username_type: this.$system.systemSettings.username_type,
            customFieldItems: [],
            form: {
                first_name: null,
                last_name: null,
                username: null,
                birthday: null,
                gender: null,
                mobile: null,
                country_id: null,
                state_id: null,
                city_id: null,
                landline: null,
                interphone: null,
                email: null,
                address: null,
                custom_fields: [],
            },
            security_form: {
                password: null,
                password_confirmation: null,
                old_password: null,
            },
            signatures: [{ id: 0, text: '' }],
            signatureHeaders: [
                {
                    title: 'دپارتمان ها',
                    key: 'department',
                    width: 130,
                },
                {
                    title: 'نقش',
                    key: 'role',
                    width: 150,
                },
                {
                    title: 'متن امضا',
                    key: 'signature',
                    width: 330,
                },
                {
                    title: '',
                    align: 'end',
                    key: 'actions',
                    width: 50,
                },
            ],
            signatureItems: [],
        };
    },
    computed: {
        haveCustomFields() {
            return this.$system.license.features.customer_custom_field && this.$system.customerCustomFields.length && !this.$auth.user.employee;
        }
    },
    methods: {
        deleteSignature(id) {
            this.$confirm(
                `<p class="mb-0 font-weight-medium mt-2">آیا از انجام این عملیات اطمینان دارید؟</p><p class="text-small mb-0 mt-2">در صورت تایید امضاء <b>${this.signatureItems.find(x => x.id == id).role} حذف خواهد شد.</p>`,
                { buttonTrueText: "حذف", buttonTrueColor: "error" }
            ).then((res) => {
                if (res)
                    this.$updateProfile({signatures: [{ id: id, text: '' }], _method: 'put'}).then(async (res) => {
                        if (res && res.status == "UPDATED") {
                            this.$toast.success(res.message);
                            await this.$auth.fetchUser(true);
                            this.recieveUserProfile();
                        }
                    });
            });
        },
        updateSignature() {
            this.$updateProfile({ signatures: this.signatures, _method: 'put' }).then(
                async (res) => {
                    if (res && res.status == "UPDATED") {
                        this.$toast.success(res.message);
                        this.editSignatureDialog = false;
                        await this.$auth.fetchUser(true);
                        this.recieveUserProfile();
                    }
                }
            );
        },
        updatePersonalInformation() {
            let form = {...this.form};
            form.custom_fields = form.custom_fields.filter(x => x.value);
            if (!this.haveCustomFields)
                delete form.custom_fields;
            form.gender = form.gender === 0 ? null : form.gender;
            if (form.username && !this.$system.systemSettings.username_change_permission)
                delete form.username;
            form._method = 'put';
            this.$updateProfile(this.$object.toFormData(form)).then(async (res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    await this.$auth.fetchUser(true);
                    this.recieveUserProfile();
                }
            });
        },
        updateSecurityInformation() {
            this.$updateProfile({...this.security_form, _method: 'put'}).then(async (res) => {
                if (res && res.status == "UPDATED") {
                    this.$toast.success(res.message);
                    await this.$auth.fetchUser(true);
                    this.recieveUserProfile();
                }
            });
        },
        recieveUserProfile() {
            this.signatureItems = [];
            if (this.$auth.user.employee) {
                if (this.$auth.user.full_admin || this.$auth.user.branch_admin) {
                    this.signatureItems = [
                        {
                            id: 1,
                            role: this.$auth.user.full_admin ? "مدیر ارشد" : "سرپرست شعبه",
                            signature: this.$auth.user.manager_information && Object.hasOwn(this.$auth.user.manager_information, 'signature') && this.$auth.user.manager_information.signature ? this.$auth.user.manager_information.signature.replace(/<[^>]*>?/gm, " ") : '',
                            completeSignature: this.$auth.user.manager_information && Object.hasOwn(this.$auth.user.manager_information, 'signature') && this.$auth.user.manager_information.signature ? this.$auth.user.manager_information.signature : '',
                        },
                    ];
                } else {
                    this.$auth.user.positions.forEach((el) => {
                        this.signatureItems.push({
                            id: el.id,
                            department: this.$system.departments.find((x) => x.id == el.department_id).name,
                            role: el.supervisor ? "سرپرست دپارتمان" : "کارشناس",
                            signature: Object.hasOwn(el, 'signature') && el.signature ? el.signature.replace(/<[^>]*>?/gm, " ") : null,
                            completeSignature: Object.hasOwn(el, 'signature') && el.signature ? el.signature : null,
                        });
                    });
                }
            }
            this.form.first_name = this.$auth.user.first_name ?? null;
            this.form.last_name = this.$auth.user.last_name ?? null;
            this.form.username = this.$auth.user.username ?? null;
            this.form.birthday = this.$auth.user.birthday ?? null;
            this.form.gender = this.$auth.user.gender ?? 0;
            this.form.mobile = this.$auth.user.mobile ?? null;
            this.form.landline = this.$auth.user.landline ?? null;
            this.form.interphone = this.$auth.user.interphone ?? null;
            this.form.email = this.$auth.user.email ?? null;
            this.form.address = this.$auth.user.address ?? null;
            if (!this.$auth.user.employee) {
                this.form.country_id = this.$auth.user.customer_information && this.$auth.user.customer_information.country_id ? this.$auth.user.customer_information.country_id : null;
                this.form.state_id = this.$auth.user.customer_information && this.$auth.user.customer_information.state_id ? this.$auth.user.customer_information.state_id : null;
                this.form.city_id = this.$auth.user.customer_information && this.$auth.user.customer_information.city_id ? this.$auth.user.customer_information.city_id : null;
                this.form.custom_fields = this.$auth.user.custom_fields ?? [];
            }
        },
        profileChanged() {
            let file = this.$refs.profileInput.getValidFiles();
            this.form.profile_picture_name = file == null ? 'unset' : file['file'];
        },
        changeTelegramToken(){
            this.changeTelegramTokenLoading = true;
            this.$updateProfile({ updateTelegramToken: true, _method: 'put' }).then(async res => {
                if(res && res.status == "UPDATED"){
                    await this.$auth.fetchUser(true);
                    this.$toast.success(res.message);
                }
            }).finally(() => this.changeTelegramTokenLoading = false)
        },
    },
    mounted() {
        this.$nextTick(async ()=>{
            this.$loading.start();
            this.signatureHeaders.splice(this.signatureHeaders.findIndex((x) => x.key == "department"), 1);
            this.recieveUserProfile();
            if(this.$auth.user.profile_picture_name)
                this.$refs.profileInput.setImageFileFromServer(this.$auth.user.profile_picture_name);
            if (this.haveCustomFields)
                this.customFieldItems = this.$system.customerCustomFields;
            await this.$system.setStatesCities();
            this.$loading.finish();
        })
    },
};
</script>
